import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import cn from 'classnames';

import BrLoader from '@components/BrLoader';
import BrPopupDialog from '@components/BrPopupDialog';
import BrTab from './BrTab';
import './brTabPanel.scss';

/* eslint-disable react/no-array-index-key */
export default class BrTabPanel extends PureComponent {
  static propTypes = {
    children: PropTypes.instanceOf(Array),
    className: PropTypes.string,
    warningMessage: PropTypes.any,
    onClickTab: PropTypes.func,
    selectedTab: PropTypes.string,
    isLoading: PropTypes.bool,
    hasUnsavedChanges: PropTypes.bool,
    unsavedChangesDialogConfig: PropTypes.shape({
      title: PropTypes.string,
      message: PropTypes.string,
      cancelButtonTitle: PropTypes.string,
      confirmButtonTitle: PropTypes.string,
    }),
    onContinueWithUnsavedChanges: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      activeTab: props.selectedTab,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.selectedTab !== nextProps.selectedTab) {
      this.setState({ activeTab: nextProps.selectedTab });
    }
  }

  onClickTabItem = (tab) => {
    // This is to handle unsaved changes of a Tab, For now this is used in Product Grid Settings
    // if hasUnsavedChanges is undefined/not passed it continues with regular flow
    // If it has unsaved changes the active tab will be set on confirmation

    if (this.props.hasUnsavedChanges) {
      const { title, message, cancelButtonTitle, confirmButtonTitle } = this.props.unsavedChangesDialogConfig;
      BrPopupDialog.openPopupDialog({
        type: BrPopupDialog.Type.ALERT_WITH_OPTION,
        title,
        message,
        cancelButtonTitle,
        confirmButtonTitle,
        onConfirm: () => {
          this.props.onContinueWithUnsavedChanges();
          this.setOnclick(tab);
        },
      });
    } else {
      this.setOnclick(tab);
    }
  };

  setOnclick = (tab) => {
    if (this.props.onClickTab) {
      this.props.onClickTab(tab);
    }
    this.setState({ activeTab: tab });
  };

  getSelectedChild = () => {
    const { children } = this.props;
    const { activeTab } = this.state;
    return children && children.filter((child) => child.props.label === activeTab).map((child) => child.props.children);
  };

  render() {
    const { children, className, isLoading, warningMessage } = this.props;
    const { activeTab } = this.state;

    return (
      <div className={cn('br-tab-panel', className)}>
        <ol className="br-tab-list">
          {children
            && children.map((child, idx) => (
              <BrTab
                activeTab={activeTab}
                key={idx}
                label={child.props.label}
                title={child.props.title}
                onClick={this.onClickTabItem}
              />
            ))}
        </ol>
        <div className="br-tab-main">
          {warningMessage ? <div className="br-tab-panel-warning">{warningMessage}</div> : null}
          {isLoading ? (
            <BrLoader className="br-tab-panel-loading" />
          ) : (
            <div className="br-tab-content">{this.getSelectedChild()}</div>
          )}
        </div>
      </div>
    );
  }
}
